<template>
  <div class="row mb-12">
    <div class="col-12 b-form__container_min-width_200">
      <div class="b-form__row_type_flex">
        <checkbox class="b-checkbox" v-model="confirmDeletion">{{$t('CONTENT.delete')}}</checkbox>
        <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.paymentDeleteHint')" icon="question"></dynamic-icon>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentDeletion from "../../models/commands/PaymentDeletion";
import dateConverter from "@/utils/converters/date.converter";

export default {
  components: {},
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      confirmDeletion: false
    };
  },
  methods: {
    cancel() {
      this.confirmDeletion = false;
    },

    save() {
      if (this.confirmDeletion) {
        const command = new PaymentDeletion(this.paymentParams.idInDB);
        this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      } else {
        const command = new PaymentDeletion(this.paymentParams.idInDB);
        this.$store.commit("eventRegistryPlugin/removeCommand", command);
      }
      return true;
    }
  }
};
</script>

<style>
</style>
